import React from 'react'
import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";
import './App.css'
import Navbar from '../src/component/navbar/navbar'
import Home from '../src/view/home'
import Login from "../src/component/login/login";
import SignUp from '../src/component/daftar/daftar'
import { Container } from "react-bootstrap";

function App() {
  return (
    <Container>
      <Router>
        <Switch>
          <Route exact path='/'>
            <Navbar />
            <Home />
          </Route>
        </Switch>
        <Switch>
          <Route exact path="/login">
            <Login />
          </Route>
        </Switch>
        <Switch>
          <Route exact path='/signup'>
            <SignUp />
          </Route>
        </Switch>
      </Router>
    </Container>
  )
}

export default App
